import React from "react";

export default function StandingsHeader({ title, live }) {
  return <>
    <header className="standings-header">
      <div className="standings-heading"><h2>{title}</h2>
        <button type="button" className="standings-live-switch" role="switch" aria-label="Livetabell" aria-checked={live.enabled} onClick={live.toggle}>
          <span>Live</span><span className="standings-live-switch__track" aria-hidden="true"><span /></span>
        </button>
      </div>
      <span>M = matcher · +/- = målskillnad</span>
    </header>
    {live.error ? <div className="standings-live-status" role="status">Live saknas just nu. Ordinarie tabell visas. <button type="button" onClick={live.retry}>Försök igen</button></div>
      : live.loading && !live.live ? <p className="standings-live-status" role="status">Hämtar livetabellen…</p> : null}
  </>;
}
